import React, { useState } from 'react';
import * as dateFns from 'date-fns';

import { useInterval } from '../../../../../helpers/customHooks';
import GameContainer from '../Events/Game';
import PracticeContainer from '../Events/Practice';
import { renderCard } from '../../../../../helpers';
import BaseLine from '../BaseLine';
import GroupedGame from '../Events/GroupedGame';
import { HourBoxPropsType } from './types';

import './Hour.scss';

const HourBox = ({ games, practices, otherGames, isToday }: HourBoxPropsType) => {
  
  const today = new Date();
  const [baseLineTop, setBaseLineTop] = useState((((dateFns.getHours(today) * 60) + dateFns.getMinutes(today)) * 1.1) - 2);
  useInterval(() => {
    const now = new Date();
    const hours = dateFns.getHours(now);
    const minutes = dateFns.getMinutes(now);
    const top = (((hours * 60) + minutes) * 1.1) - 2;
    setBaseLineTop(top);
  }, 60000);
  
  const START_HOUR = 0;
  const LAST_HOUR = 23;
  games = games.map(game => {
    return {
      ...game,
      homeTeamAbbr: game.homeTeamAbbr,
      visitorTeamAbbr: game.visitorTeamAbbr,
      homeTeamScoreTotal: !game.isFuture && game.score && game.score.homeTeamScore ? game.score.homeTeamScore.pointTotal : 0,
      visitorTeamScoreTotal: !game.isFuture && game.score && game.score.visitorTeamScore ? game.score.visitorTeamScore.pointTotal : 0,
      speed: {
        A: game.speed.A,
        B: game.speed.B
      },
      dist: {
        A: game.dist.A,
        B: game.dist.B
      },
      effort: {
        A: game.effort.A,
        B: game.effort.B
      }
    };
  });
  otherGames = otherGames.map(game => {
    return {
      ...game,
      homeTeamAbbr: game.homeTeamAbbr,
      visitorTeamAbbr: game.visitorTeamAbbr,
      homeTeamScoreTotal: !game.isFuture && game.score && game.score.homeTeamScore ? game.score.homeTeamScore.pointTotal : 0,
      visitorTeamScoreTotal: !game.isFuture && game.score && game.score.visitorTeamScore ? game.score.visitorTeamScore.pointTotal : 0,
      speed: {
        A: game.speed.A,
        B: game.speed.B
      },
      dist: {
        A: game.dist.A,
        B: game.dist.B
      },
      effort: {
        A: game.effort.A,
        B: game.effort.B
      }
    };
  });
  const group1Games = [...otherGames.filter(game => {
    return game.groupTime.group === 1;
  }), ...games.filter(game => game.groupTime.group === 1)];
  const group2Games = [...otherGames.filter(game => {
    return game.groupTime.group === 2;
  }), ...games.filter(game => game.groupTime.group === 2)];
  const group3Games = [...otherGames.filter(game => {
    return game.groupTime.group === 3;
  }), ...games.filter(game => game.groupTime.group === 3)];
  const hours = [];
  for (let currentHour = START_HOUR; currentHour <= LAST_HOUR; currentHour++) {
    let otherGamesCard;
    let dayGames;
    const dayPractices = renderCard(practices, currentHour, PracticeContainer);
    if (group1Games && group1Games.length > 0) {
      if (currentHour === group1Games[0].groupTime.tzhour) {
        if (games.length > 0 && currentHour === games[0].groupTime.tzhour) {
          dayGames = <GameContainer event={games[0]} games={group1Games} />;
        } else {
          otherGamesCard = <GroupedGame games={group1Games} />;
        }
      }
    }
    if (group2Games && group2Games.length > 0) {
      if (currentHour === group2Games[0].groupTime.tzhour) {
        if (games.length > 0 && currentHour === games[0].groupTime.tzhour) {
          dayGames = <GameContainer event={games[0]} games={group2Games} /*half*/ />;
        } else {
          otherGamesCard = <GroupedGame games={group2Games} half />;
        }
      }
    }
    if (group3Games && group3Games.length > 0) {
      if (currentHour === group3Games[0].groupTime.tzhour) {
        if (games.length > 0 && currentHour === games[0].groupTime.tzhour) {
          dayGames = <GameContainer event={games[0]} games={group3Games} />;
        } else {
          otherGamesCard = <GroupedGame games={group3Games} />;
        }
      }
    }
    // if (currentHour===20) {
    //   otherGamesCard = otherGames&&otherGames.length>0?<GroupedGame games={otherGames}/>:null;
    // }
    hours.push(
      <div
        key={currentHour}
        className="hour-item"
        style={dateFns.isThisHour(currentHour) ? { borderBottomColor: 'black' } : {}}
      >
        {otherGamesCard}
        {dayGames}
        {dayPractices}
        <div className="half-hour" />
      </div>
    );
  }
  
  return (
    <div>
      <BaseLine isToday={isToday} top={baseLineTop} />
      {hours}
    </div>
  );
};

export default HourBox;
